import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function AboutAuthor() {
  return <section className="bg-deeper-beige py-24 px-6 relative overflow-hidden" data-id="element-11">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-cream rounded-full mix-blend-overlay filter blur-3xl opacity-50" data-id="element-12"></div>

      <div className="max-w-5xl mx-auto" data-id="element-13">
        <AnimatedSection className="bg-white rounded-3xl shadow-warm-lg p-8 md:p-12 flex flex-col md:flex-row items-center gap-12" data-id="element-14">
          <div className="w-48 h-48 md:w-64 md:h-64 flex-shrink-0 rounded-full bg-warm-beige border-4 border-cream shadow-inner overflow-hidden relative" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/w6KgtXEH8kV5DVoC3EhA3i/PORTADA_3.jpg" alt="Daniela Garcia Lantigua, autora de Rompiendo el Silencio" className="w-full h-full object-cover object-top" data-id="element-16" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-17">
            <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-18">
              Sobre la Autora
            </h2>
            <h3 className="text-xl text-terracotta font-medium mb-6" data-id="element-19">
              Daniela Garcia Lantigua
            </h3>
            <div className="space-y-4 text-medium-brown text-lg leading-relaxed" data-id="element-20">
              <p data-id="element-21">
                Como sobreviviente y defensora, Daniela ha dedicado su vida a
                transformar el dolor en propósito. Su viaje personal a través de
                la sanación del abuso infantil la inspiró a crear recursos para
                otros que caminan por senderos similares.
              </p>
              <p data-id="element-22">
                Con una voz compasiva y valiente, Daniela rompe los estigmas
                asociados al trauma infantil, ofreciendo no solo su testimonio,
                sino herramientas reales para el empoderamiento y la
                reconstrucción personal.
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}